import { Modal, Button } from 'react-bootstrap'
import { StyledConfirmModal } from './GroundingConfirmModal.styled'
import { divide } from 'lodash'

interface IProps {
  header?: string
  content: string
  show: boolean
  events?: {
    onClose?: any
    setShowModal?: any
    handleAcknowledgedConfirm?: any
    handleClickXButton?: any
  }
  isShowHeader?: boolean
  isShowButton?: boolean
  isEmbedHtml?: boolean
  isShowYesButton?: boolean
  isShowNoButton?: boolean
  isBackdropStatic?: boolean
}

export const GroundingConfirmModal = ({
  content,
  show,
  events,
  header,
  isShowHeader,
  isShowButton,
  isEmbedHtml,
  isShowYesButton,
  isShowNoButton,
  isBackdropStatic
}: IProps) => {
  return (
    <StyledConfirmModal
      show={show}
      onHide={() => events.handleClickXButton()}
      backdrop={isBackdropStatic ? 'static' : true}
      centered
    >
      {isShowHeader && (
        <Modal.Header closeButton>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>
        {isEmbedHtml ? <div dangerouslySetInnerHTML={{ __html: content }}></div> : <div>{content}</div>}
        {isShowButton && (
          <div className="modal-btn-group">
            <Button onClick={events.handleAcknowledgedConfirm}>{isShowYesButton ? 'Yes' : 'OK'}</Button>
            <Button className="btn-secondary" onClick={() => events.onClose()}>
              {isShowNoButton ? 'No' : 'Cancel'}
            </Button>
          </div>
        )}
      </Modal.Body>
    </StyledConfirmModal>
  )
}
export default GroundingConfirmModal
